import { AppointmentStatus, AppointmentType, type ICalendarEvent } from '@torim-app/types';

export interface IAppointmentStatusMark {
  icon: string;
  /** Disc / chip foreground. */
  fg: string;
  /** Chip tint. */
  bg: string;
  label: string;
  title: string;
}

/**
 * The calendar's approval-status mark. Colour on a block identifies the service; this is
 * what tells an employee whether the visit is confirmed.
 *
 * - waiting for the business's approval → amber clock (needs action)
 * - customer confirmed (approved / finished) → green ✓
 * - booked, not confirmed yet (verified) → nothing; it's the default state
 *
 * Only customer appointments have an approval status — manual blocks and out-of-office are
 * stored as approved too, but there's nobody to confirm them.
 */
export const getAppointmentStatusMark = (event: ICalendarEvent): IAppointmentStatusMark | null => {
  if (event.type !== AppointmentType.EVENT) return null;
  if (event.status === AppointmentStatus.WAITING_FOR_BUSINESS_APPROVAL) {
    return { icon: 'pi-clock', fg: '#b45309', bg: '#fef3c7', label: 'ממתין לאישורכם', title: 'ממתין לאישורכם' };
  }
  if (event.status === AppointmentStatus.APPROVED || event.status === AppointmentStatus.FINISHED) {
    return { icon: 'pi-check', fg: '#15803d', bg: '#dcfce7', label: 'אישר/ה הגעה', title: 'הלקוח/ה אישר/ה הגעה' };
  }
  return null;
};
